<script setup lang="ts">
// import { authStore, AuthStoreType } from "~/stores/authStore";
import localforage from "localforage";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { authStore } from "~/stores/authStore";
import { useMyInfoStore } from "~/stores/MyInfoStore";
import { AuthStoreType } from "~/types/auth";
import { apiClient } from "~/utils/apiClient";
import { commitBuildInfo } from "~/utils/miscUtils";
import logo from "../assets/YYCSeniorsIntakeLOGO.png";

const router = useRouter();

const myInfoStore = useMyInfoStore();

const props = defineProps<{
  showPortalLoginButton: boolean;
}>();

onMounted(async () => {
  await myInfoStore.load();
});

const hmbLogin = async () => {
  if (!props.showPortalLoginButton) {
    return;
  }
  await authStore
    .login(AuthStoreType.Hmb)
    .then(() => {
      router.push({ name: "Dashboard" });
    })
    .catch((err) => {
      console.warn(err);
    });
};
const userLogin = async () => {
  await authStore
    .login(AuthStoreType.User)
    .then(() => {
      router.push({ name: "applicationHome" });
    })
    .catch((err) => {
      console.warn(err);
    });
};
// const userSilentLogin = async () => {
// await authStore
//   .silentLogin(AuthStoreType.User)
//   .then(() => {
//     router.push({ name: "applicationHome" });
//   })
//   .catch((err) => {
//     console.warn(err);
//   });
// };
const userSignUp = async () => {
  userLogin();
  // TODO: this is just for testing. we need to refine the auth flow.
  // router.push({ name: "applicationHome" });
  // authStore.signUpFlow = true;
  // await authStore
  //   .login(AuthStoreType.SignUp)
  //   .then(() => {
  //     userSilentLogin();
  //   })
  //   .catch((err) => {
  //     console.warn(err);
  //   });
};
const isLoggingOut = ref(false);
const logout = async () => {
  if (isLoggingOut.value) {
    return;
  }
  isLoggingOut.value = true;

  sessionStorage.removeItem("currentOrgGuid");

  const token = await authStore.getAccessTokenAsync();

  if (token) {
    await apiClient.userInfo.forgetAboutMe();
  } else {
    console.warn("No Token");
  }
  await authStore.logout().then(() => {
    localforage.clear();
    isLoggingOut.value = false;
    router.push("/");
  });
};
</script>

<template>
  <div class="IntakeTopBar">
    <div class="title" @click="$router.push('/')">
      <img
        :src="logo"
        alt="YYC Seniors Housing"
        :title="commitBuildInfo"
        class="logo"
      />
    </div>

    <h1>Housing Application</h1>

    <div v-if="myInfoStore.isLoggedIn">
      <div class="loginButtons">
        <el-link
          v-if="myInfoStore.isPortal"
          @click="() => router.push({ name: 'Dashboard' })"
        >
          Portal
        </el-link>
        <div>
          {{ myInfoStore.userInfo?.loginName }}
        </div>

        <el-link type="default" :disabled="isLoggingOut" @click="logout">
          Logout
        </el-link>
      </div>
    </div>
    <div v-else>
      <div class="loginButtons">
        <el-link v-if="showPortalLoginButton" @click="hmbLogin">
          Portal Login
        </el-link>
        <el-link @click="userLogin"> Login </el-link>
        <el-link @click="userSignUp"> Apply Now </el-link>
      </div>
    </div>
  </div>
</template>

<style lang="less">
.IntakeTopBar {
  height: var(--el-header-height);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    display: flex;
    align-items: center;
    gap: 2em;
    cursor: pointer;
  }
  h1 {
    font-weight: 500;
    color: var(--el-color-primary);
    @media (max-width: 801px) {
      font-size: 1em;
    }
    @media (max-width: 550px) {
      display: none;
    }
    @media (min-width: 550px) and (max-width: 600px) {
      font-size: 1rem;
    }
  }

  .logo {
    height: calc(var(--el-header-height) * 0.8);
    padding-top: 2px;
    @media (max-width: 800px) {
      height: calc(var(--el-header-height) * 0.5);
    }
    @media (max-width: 500px) {
      height: calc(var(--el-header-height) * 0.3);
    }
  }

  a.el-button {
    text-decoration: none;
  }

  .loginButtons {
    display: flex;
    align-items: center;
    gap: 3em;
    @media (max-width: 850px) {
      font-size: 0.9rem;
    }
    @media (max-width: 450px) {
      font-size: 0.6rem;
      .el-link__inner {
        font-size: 0.8rem;
      }
    }
    @media (min-width: 450px) and (max-width: 600px) {
      font-size: 1rem;
      .el-link__inner {
        font-size: 1rem;
      }
    }
  }
}
</style>
